import Swal from 'sweetalert2'
import { useContext, useEffect, useState } from 'react';

import EmailContext from 'context/EmailContext';

import {
    getAll,
    create,
    update,
    del,
    getVinculedEmailsWithClient,
    vinculedEmail,
    desvinculedEmail
} from "services/EmailService.js";

let totalPages;

export function useEmail() {
    const [page, setPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(5)
   
    const {
        setEmail,
        allEmails,
        setAllEmails,
        emails,
        setEmails,
        vinculedEmails,
        setVinculedEmails,
        message,
        setMessage,
        loading,
        setLoading
    } = useContext(EmailContext);

    
    const getAllEmails = async ({ numDocument, email }) => {
        try {
            const response = await getAll({ numDocument, email });
            setAllEmails(response)
            return response
        } catch (err) {
            const { data, status } = err.response;
            setMessage({ message: data.message, status });
        }
    }

    const getEmails = async ({page = 1, limit = itemsPerPage, numDocument, email}) => {
        setLoading(true);
        setPage(page);
        try {
            const allEmails = await getAllEmails({numDocument, email});
            setAllEmails(allEmails);
            totalPages = Math.ceil(allEmails.length / limit)
            const emails = await getAll({ page, limit, numDocument, email});
            setEmails(emails);
            setLoading(false);
        } catch (err) {
            const { data, status } = err.response;
            setMessage({ message: data.message, status });
            setLoading(false);
        }
    }

    const getVinculedEmails = async ({numDocument}) => {
        setLoading(true);
        try {
            const response = await getVinculedEmailsWithClient({numDocument});
            setVinculedEmails(response);
            setLoading(false);
            return response
        } catch (err) {
            const { data, status } = err.response;
            const message = data.message;
            setMessage({ message, status });
            Swal.fire(
                'Ocurrió un Error!!!',
                message,
                'error'
            )
            setLoading(false);
        }
    }

    const likeEmail = async({email, cliente}) => {
        const idEmail = email._id;
        const idCliente = cliente._id;
        setLoading(true);
        try {
            const {message} = await vinculedEmail({idEmail, idCliente});
            setMessage({ message, status: 200 });
            Swal.fire(
                'Éxito!!!',
                message,
                'success'
            )
            setLoading(false);
            return cliente.numDocument;
        } catch (err) {
            const { data, status } = err.response;
            const message = data.message;
            
            setMessage({ message, status });
            Swal.fire(
                'Ocurrió un Error!!!',
                message,
                'error'
            )
            setLoading(false);
        }
    }

    const unlikeEmail = async ({email, cliente}) => {
        const idEmail = email._id;
        const idCliente = cliente._id
        setLoading(true);
        try {
            const {message} = await desvinculedEmail({idEmail, idCliente});
            setMessage({ message, status: 200 });
            Swal.fire(
                'Éxito!!!',
                message,
                'success'
            )
            setLoading(false);
            return cliente.numDocument;
        } catch (err) {
            const { data, status } = err.response;
            const message = data.message;
            
            setMessage({ message, status });
            Swal.fire(
                'Ocurrió un Error!!!',
                message,
                'error'
            )
            setLoading(false);
        }
    }

    const createEmail = async ({ email }) => {
        try {
            const { message } = await create({ email })
            setMessage(state => ({ ...state, message }))
            Swal.fire(
                'Éxito!!!',
                message,
                'success'
            )
            getEmails({ page })
            return ''
        } catch (err) {
            const { data, status } = err.response
            setMessage({ message: data.message, status })
            return status
        }
    }

    const updateEmail = async ({ email, id }) => {
        try {
            const { message } = await update({ email, id })
            setMessage({ message: '', status: 200 })
            Swal.fire(
                'Éxito!!!',
                message,
                'success'
            )
            getEmails({ page })
            return ''
        } catch (err) {
            const { data, status } = err.response
            setMessage({ message: data.message, status })
            return status
        }
    }

    const deleteEmail = async ({ id }) => {
        Swal.fire({
            title: 'Estás seguro?',
            text: '¡No podrás revertir esto!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Si, eliminar!',
            cancelButtonText: 'Cancelar'
        }).then((result) => {
            if (result.isConfirmed) {
                (async () => {
                    try {
                        const { message } = await del({ id })
                        setMessage({ message: '', status: 200 })

                        Swal.fire(
                            'Éxito!!!',
                            message,
                            'success'
                        )
                        getEmails({ page })
                    } catch (err) {
                        const { data, status } = err.response
                        setMessage({ message: data.message, status })
                        Swal.fire({
                            icon: 'error',
                            title: 'Oops...',
                            text: data.message,
                        })
                    }
                })();
            }
        })
    }

    useEffect(() => {
        getEmails({});
        // eslint-disable-next-line
    }, [])

    return { 
        allEmails,
        emails,
        setEmail,
        page,
        totalPages,
        status: message.status,
        loading,
        deleteEmail,
        updateEmail,
        createEmail,
        getEmails,
        setPage,
        vinculedEmails,
        getVinculedEmails,
        likeEmail,
        unlikeEmail,
        itemsPerPage,
        setItemsPerPage,
    }
}